import { PrimitiveAnchor, Typography } from '@flex-design-system/fx';
import { css } from '@flex-design-system/stitches-react';
import {
  addDays,
  createNow,
  isAfter,
  isBefore,
  parseISO,
} from '@flex-packages/date';
import { useFormatV2 } from '@flex-packages/datetime-react/hooks';
import { Translation, useLanguage } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';

import {
  CONTENT_HORIZONTAL_PADDING,
  CONTENT_HORIZONTAL_PADDING_MOBILE,
} from '../../configs/style';
import { useRendererProps } from '../../contexts';
import { getMobileStyle } from '../../utils';

const now = createNow();

const POLICY_EFFECTIVE_DATE = '2026-02-23';
const EXPOSED_FROM_DATE = '2026-02-16';
const EXPOSED_UNTIL_DATE = '2026-02-23';
const 플렉스팀_CUSTOMER_ID_HASH = '65Y06m8XpK';
const INTERCOM_NOTICE_URL =
  'https://recruit-privacypolicy.flex.team/ko/articles/13164171-%EC%B1%84%EC%9A%A9%EC%9D%84-%EC%9C%84%ED%95%9C-flex-%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4-%EC%B2%98%EB%A6%AC%EB%B0%A9%EC%B9%A8-%EB%B3%80%EA%B2%BD-%EC%95%88%EB%82%B4-2026-02-23-%EC%8B%9C%ED%96%89';

export function PrivacyPolicyNoticeBanner() {
  const { siteDesign } = useRendererProps();

  const locale = useLanguage();
  const format = useFormatV2({ locale });

  if (
    isBefore(now, parseISO(EXPOSED_FROM_DATE)) ||
    isAfter(now, addDays(parseISO(EXPOSED_UNTIL_DATE), 1))
  ) {
    return null;
  }

  if (siteDesign.customerIdHash !== 플렉스팀_CUSTOMER_ID_HASH) {
    return null;
  }

  return (
    <div className={root().className}>
      <PrimitiveAnchor
        className={content().className}
        href={INTERCOM_NOTICE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className={badge().className}>
          <Typography size={12} color="#c6c6c6" weight={700}>
            NOTICE
          </Typography>
        </div>
        <Typography
          lineHeight="138%"
          size={14}
          color="white096"
          weight={500}
          asChild
        >
          <Translation
            tKey={trans(
              'recruiting.site_builder.privacy_policy_notice_banner.text'
            )}
            tOptions={{
              values: {
                date: format({
                  date: parseISO(POLICY_EFFECTIVE_DATE),
                  presetName: 'date_short',
                }),
              },
            }}
          />
        </Typography>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="9"
          viewBox="0 0 6 9"
          fill="none"
        >
          <path
            opacity="0.66"
            d="M0.424255 8.42426L4.42426 4.42426L0.424255 0.424265"
            stroke="white"
            strokeOpacity="0.6"
            strokeWidth="1.2"
          />
        </svg>
      </PrimitiveAnchor>
    </div>
  );
}

const root = css({
  width: '100%',
  backgroundColor: '$black',
});

const content = css({
  width: '100%',
  height: '100%',

  display: 'flex',
  alignItems: 'center',
  gap: 12,

  padding: `14px ${CONTENT_HORIZONTAL_PADDING}px`,

  ...getMobileStyle({
    padding: `11px ${CONTENT_HORIZONTAL_PADDING_MOBILE}px`,
  }),
});

const badge = css({
  display: 'flex',
  height: 20,
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  padding: '0 8px',
  borderRadius: 18,
  border: '1px solid #c6c6c6',

  color: '$white096',
});
